import _ from "lodash"
import { InputContainer } from "../../../../../common/components/form/input/containers/input.container";
import { HiOutlineTrash } from "react-icons/hi";

export const ProgramKeywordMappingComponent = ({ handleFormKeywordItemChange, keywords,deleteKeywordItems }: any) => {
    return (
<>
{ _.map(
  keywords,
  (selectedKeywords: any, itemIndex: any) => (
                      <div className=" py-4 border-b">
                        <div className=" grid md:grid-cols-3 lg:grid-cols-4 gap-4">
                        <InputContainer
          label="Keyword"

          onValueChange={(event: any, newValue: any) => {
            handleFormKeywordItemChange({
              value: event.target.value,
              field: 'Keyword',
              idx: itemIndex
            });
          }}
          type="text"
          value={selectedKeywords?.Keyword}

      />

<InputContainer
          label="Description"

          onValueChange={(event: any, newValue: any) => {
            handleFormKeywordItemChange({
              value: event.target.value,
              field: 'Description',
              idx: itemIndex
            });
          }}
          type="text"
          value={selectedKeywords?.Description}

      />
      {selectedKeywords?.Keyword ? (
                <button className="text-red-500 hover:text-red-700" onClick={async () => deleteKeywordItems(selectedKeywords, itemIndex)}>
                    <HiOutlineTrash className="w-6 h-6" />
                  </button>) :(<></>)}
                        </div>
                        </div>
  ))}
  </>
    )
}